module.exports = __webpack_public_path__ + "img/desktop_hexagon_white_outlined_token.fcf18562.png";